<template>
  <div>
    <BoltDialog v-model="showingBolt" />
    <v-btn fab small color="white" @click="showingBolt = true" class="mx-4">
      <v-icon color="black">flash_on</v-icon>
    </v-btn>
  </div>
</template>

<script>
import BoltDialog from './BoltDialog.vue'

export default {
  components: { BoltDialog },
  data() {
    return {
      showingBolt: false,
      boltShortcutListener: null
    }
  },
  mounted() {
    this.boltShortcutListener = (evt) => {
      let key = evt && evt.key,
        targetTag = evt.target.tagName

      if (key == '/' && targetTag != 'INPUT' && targetTag != 'TEXTAREA') {
        this.showingBolt = true
        evt.preventDefault()
      }
    }

    document.addEventListener('keydown', this.boltShortcutListener)
  },
  beforeDestroy() {
    if (this.boltShortcutListener)
      document.removeEventListener('keydown', this.boltShortcutListener)
  }
}
</script>

<style></style>
